import React, { useEffect, useState } from 'react';
import { getDecryptedAccessToken } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../../../Utils/ApiServices/ApiServices';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const AllMembershipPlan = () => {
  const accessToken = getDecryptedAccessToken();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMembershipPlans = async () => {
    try {
      const response = await ApiServices.get('/apis/default/api/membership', {
        Authorization: `Bearer ${accessToken}`,
      });
      setPlans(response.data || []);
    } catch (error) {
      console.error('Error fetching membership plans:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembershipPlans();
  }, [accessToken]);

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        All Membership Plans
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Grid container spacing={3}>
          {plans.map((plan) => (
            <Grid item xs={12} sm={6} md={4} key={plan.id}>
              <Card sx={{ borderRadius: 3, boxShadow: 4 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom color="primary">
                    {plan.plan_tier}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                    {plan.type_name}
                  </Typography>

                  <Typography variant="body2" fontWeight="bold" gutterBottom>
                    Benefits:
                  </Typography>
                  {plan.benefits.length > 0 ? (
                    <List dense>
                      {plan.benefits.map((benefit, idx) => (
                        <ListItem key={idx} sx={{ pl: 0 }}>
                          <ListItemIcon sx={{ minWidth: 32 }}>
                            <CheckCircleIcon color="success" fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary={benefit} />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No benefits added.
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default AllMembershipPlan;
